import React, { Fragment } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Accordion,
  Typography,
  AccordionSummary,
  AccordionDetails,
  ListItem,
  Avatar,
  Link,
  CircularProgress
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { isEmpty } from 'lodash';
import Warning from '../Icons/warning';
import settings from '../../../utils/settings';
import { get } from '../../../utils/lodash';
import { getPlatformBasedUrl } from '../../../config/platformBasedUrls/url';

const useStyles = makeStyles(theme => ({
  table: {
    height: theme.spacing(53.5),
    overflowY: 'scroll',
    [theme.breakpoints.down('xs')]: {
      height: theme.spacing(38.5)
    }
  },
  accordianDetails: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0
  },
  accordingHeading: {
    margin: '0 !important'
  },
  accordian: {
    boxShadow: 'none',
    margin: '0 !important'
  },
  expandMoreicon: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1)
  },
  heading: {
    color: theme.palette.primary.blue,
    fontSize: 15,
    maxWidth: theme.spacing(27),
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  subHeading: {
    fontSize: 14
  },
  columnNames: {
    minWidth: theme.spacing(10),
    fontSize: 13
  },
  values: {
    position: 'absolute',
    right: 0,
    fontSize: 13,
    color: theme.palette.primary.lightBlack
  },
  listItems: {
    padding: theme.spacing(0.2, 0, 0.2, 0)
  },
  contentStyles: {
    margin: '10px 0px !important'
  },
  displayBlock: {
    display: 'block'
  },
  statusIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.62),
    borderRadius: '0px',
    display: 'inline-block',
    overflow: 'unset',
    marginRight: theme.spacing(0.5),
    top: theme.spacing(0.25)
  },
  linkTableCell: {
    color: theme.palette.tertiary.main
  },
  loader: {
    marginLeft: '45%',
    marginTop: '40%'
  },
  inactiveBadge: {
    backgroundColor: theme.palette.primary.darkGray,
    color: theme.palette.primary.dark,
    borderRadius: theme.spacing(5),
    padding: theme.spacing(0.2, 0.8),
    fontSize: 9,
    position: 'relative',
    left: theme.spacing(0.8),
    bottom: theme.spacing(0.9)
  },
  initialOverflow: {
    overflow: 'initial'
  }
}));

const Table = props => {
  const {
    objectsList = [],
    headingColumn = '',
    subHeadingColumn = '',
    subHeadingColumnIcons = '',
    displayColumns = [],
    keyValue = '',
    columnNames = [],
    menuType = '',
    companyId,
    currentlySending = false
  } = props;
  const classes = useStyles();

  let heading = '';
  let subHeadingColumnIcon = '';

  const getSystemTableRowDetails = object => {
    const { envoyNotReporting, normalIcon, storage, micro } = subHeadingColumnIcons;
    const status = object.status;
    const url =
      menuType === 'Leads'
        ? getPlatformBasedUrl('dashboard.systemsTable.leadURL', {
            companyId,
            id: object.id,
            journey_type: object.journey_type
          })
        : menuType === 'Activations'
          ? settings.enlightenMenuUrl(`activations/edit/${object.id}`)
          : settings.enlightenMenuUrl(`systems/${object.id}`);
    heading = (
      <Link target="_blank" className={classes.linkTableCell} href={url}>
        {object[headingColumn]}
      </Link>
    );
    if ((menuType !== 'All' && menuType !== 'Alerts') || subHeadingColumnIcons === '') {
      subHeadingColumnIcon = <Fragment />;
    } else if (status === 'normal') {
      subHeadingColumnIcon = <Avatar alt="selected" src={normalIcon} className={classes.statusIcon} />;
    } else if (status === 'comm') {
      subHeadingColumnIcon = <Avatar alt="selected" src={envoyNotReporting} className={classes.statusIcon} />;
    } else if (status === 'battery' || 'storage_idle') {
      subHeadingColumnIcon = <Avatar alt="selected" src={storage} className={classes.statusIcon} />;
    } else if (status === 'micro') {
      subHeadingColumnIcon = <Avatar alt="selected" src={micro} className={classes.statusIcon} />;
    } else {
      subHeadingColumnIcon = <Warning className={classes.statusIcon} />;
    }
  };

  return (
    <Box className={classes.table}>
      {currentlySending ? (
        <CircularProgress className={classes.loader} size={25} />
      ) : (
        !isEmpty(objectsList) &&
        objectsList.map((object, ind) => {
          let i = 0;
          if (keyValue === 'system_table') getSystemTableRowDetails(object);
          const isInActive = menuType === 'Leads' && !get(object, 'is_active', true);
          return (
            <Accordion className={classes.accordian} key={`accordian-${keyValue}-${menuType}-${ind}`}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                classes={{
                  content: classes.contentStyles
                }}
              >
                <Box className={classes.displayBlock}>
                  <Typography className={clsx(classes.heading, menuType === 'Leads' && classes.initialOverflow)}>
                    {heading}
                    {isInActive && <span className={classes.inactiveBadge}>Inactive</span>}
                  </Typography>
                  <Box className={classes.subHeading}>
                    {subHeadingColumnIcon}
                    {subHeadingColumn !== '' && object[subHeadingColumn]}
                  </Box>
                </Box>
              </AccordionSummary>
              <AccordionDetails className={classes.accordianDetails}>
                {Object.keys(object).map(function(keyName, keyIndex) {
                  return (
                    displayColumns.includes(keyName) && (
                      <ListItem key={`object-${keyValue}-${menuType}-${ind}-${keyIndex}`} className={classes.listItems}>
                        <span className={classes.columnNames}>{columnNames[i++]}</span>
                        <span className={classes.values}>{object[keyName] || 'NA'}</span>
                      </ListItem>
                    )
                  );
                })}
              </AccordionDetails>
            </Accordion>
          );
        })
      )}
    </Box>
  );
};

export default Table;
